app.directive('backTopButton', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            color: '=?',
            offset: '=?'
        },
        template: '<button class="circular ui icon button back__to__top" ng-class="color"><i class="arrow up icon"></i></button>',
        link: function (scope, element) {
            scope.color = scope.color || 'primary';
            scope.offset = scope.offset || 0;
            scope.$element = $(element);
            scope.hideElement = function () {
                scope.$element.hide();
            };
            scope.showElement = function () {
                scope.$element.show();
            };
            scope.onScroll = function () {
                if ($(window).scrollTop() <= parseInt(scope.offset, 10)) {
                    scope.hideElement();
                } else {
                    scope.showElement();
                }
            };
            scope.onElementClick = function () {
                $('html, body').animate({scrollTop: 0}, 'fast');
            };

            if (!scope.$element || !scope.$element.length) {
                return;
            }

            scope.hideElement();
            scope.onScroll();
            $(window).scroll(scope.onScroll);
            scope.$element.on('click', scope.onElementClick);
        }
    }
});
